import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { DarkModeModule } from '../dark-mode/dark-mode.module';
import { HomeComponent } from './home.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { MatTreeModule } from '@angular/material/tree';

@NgModule({
  declarations: [HomeComponent, MainMenuComponent, UserMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    DarkModeModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatMenuModule,
    MatButtonModule,
    MatListModule,
    LayoutModule,
    MatTreeModule,
  ],
})
export class HomeModule {}
